import React from "react";
import { useLanguage } from "../../../../contexts";
import "../RiskMatrixGuide/RiskMatrixGuide.scss";

export function EsrsGuide() {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  return (
    <div className="risk-matrix-guide">
      <h2>{t("risk_matrix_esrs_guide_title")}</h2>
      <p>{t("risk_matrix_esrs_guide_intro")}</p>
      <ol>
        <li>{t("risk_matrix_esrs_guide_step1")}</li>
        <li>{t("risk_matrix_esrs_guide_step2")}</li>
        <li>{t("risk_matrix_esrs_guide_step3")}</li>
        <li>{t("risk_matrix_esrs_guide_step4")}</li>
      </ol>

      <div className="risk-matrix-guide__note">{t("risk_matrix_esrs_guide_auto_note")}</div>

      <h3>{t("risk_matrix_guide_criteria_title")}</h3>
      <table className="risk-matrix-guide__table">
        <thead>
          <tr>
            <th>{t("risk_matrix_esrs_col_theme_side")}</th>
            <th>{t("risk_matrix_guide_criteria_use")}</th>
            <th>{t("risk_matrix_esrs_col_source")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t("risk_matrix_esrs_impact_side")}</td>
            <td>{t("risk_matrix_esrs_impact_side_use")}</td>
            <td>GRI 3 / ESRS 1</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_esrs_financial_side")}</td>
            <td>{t("risk_matrix_esrs_financial_side_use")}</td>
            <td>IFRS S1/S2 / ESRS 1 AR 15</td>
          </tr>
          <tr>
            <td>{t("risk_matrix_esrs_double_side")}</td>
            <td>{t("risk_matrix_esrs_double_side_use")}</td>
            <td>ESRS 1</td>
          </tr>
        </tbody>
      </table>

      <div className="risk-matrix-guide__ref">{t("risk_matrix_esrs_guide_traceability")}</div>
    </div>
  );
}
